import { ReactNode, memo } from 'react';
import clsx from 'clsx';
import { Flex } from 'antd';
import LazySvg from 'components/LazySvg';
import styles from './index.module.scss';

type TitleProps = {
  children: ReactNode;
  section?: boolean;
  className?: string;
  qaSelector?: string;
};

type DescriptionProps = {
  children: ReactNode;
  section?: boolean;
  bold?: boolean;
  className?: string;
  qaSelector?: string;
};

function PageTitleComp({
  children,
  section = false,
  className = '',
  qaSelector,
}: TitleProps) {
  if (section) {
    return (
      <h3
        className={`${styles.sectionTitle} ${className}`}
        data-qa-selector={qaSelector}
      >
        {children}
      </h3>
    );
  }

  return (
    <h1
      className={`${styles.pageTitle} ${className}`}
      data-qa-selector={qaSelector}
    >
      {children}
    </h1>
  );
}

function PageDescriptionComp({
  children,
  section = false,
  bold = false,
  className = '',
  qaSelector,
}: DescriptionProps) {
  const descriptionClassName = clsx(className, {
    [styles.sectionDescription]: section,
    [styles.pageDescription]: !section,
    [styles.bold]: bold,
  });
  return (
    <p className={descriptionClassName} data-qa-selector={qaSelector}>
      {children}
    </p>
  );
}

function EnrollmentPageBadgesComp() {
  return (
    <Flex className='alignStretch gap40' align='center' justify='center'>
      <LazySvg name='bbb-badge' fallback={null} />
      <LazySvg name='tls-badge' fallback={null} />
    </Flex>
  );
}

export const PageTitle = memo(PageTitleComp);
export const PageDescription = memo(PageDescriptionComp);
export const EnrollmentPageBadges = memo(EnrollmentPageBadgesComp);
